const initialState = {
    //get important Benefits
    importantFetching: false,
    importantFetched: false,
    importantData: {},
    importantError: null,
    //get segmentation
    segmentationFetching: false,
    segmentationFetched: false,
    segmentationData: {},
    segmentationError: null,
    //add segmentation
    editFetching: false,
    editFetched: false,
    editData: {},
    editError: null,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_SEGMENTATION_PENDING': {
            state = Object.assign({}, state, { segmentationFetching: true, segmentationFetched: false });
            break;
        }
        case "GET_SEGMENTATION_FULFILLED": {
            state = Object.assign({}, state, { segmentationFetching: false, segmentationFetched: true, segmentationData: action.data });
            break;
        }
        case 'GET_SEGMENTATION_REJECTED': {
            state = Object.assign({}, state, { segmentationFetching: false, segmentationFetched: false, segmentationData: {}, segmentationError: action.error });
            break;
        }

        case 'GET_IMORTANT_BENEFITS_PENDING': {
            state = Object.assign({}, state, { importantFetching: true, importantFetched: false });
            break;
        }
        case "GET_IMORTANT_BENEFITS_FULFILLED": {
            state = Object.assign({}, state, { importantFetching: false, importantFetched: true, importantData: action.data });
            break;
        }
        case 'GET_IMORTANT_BENEFITS_REJECTED': {
            state = Object.assign({}, state, { importantFetching: false, importantFetched: false, importantData: {}, importantError: action.error });
            break;
        }

        case 'EDIT_SEGMENTATION_PENDING': {
            state = Object.assign({}, state, { editFetching: true, editFetched: false });
            break;
        }
        case "EDIT_SEGMENTATION_FULFILLED": {
            state = Object.assign({}, state, { editFetching: false, editFetched: true, editData: action.data });
            break;
        }
        case 'EDIT_SEGMENTATION_REJECT': {
            state = Object.assign({}, state, { editFetching: false, editFetched: false, editData: {}, editError: action.error });
            break;
        }
        case 'RESET_IMPORTANTS': {
            state = Object.assign({}, state, {  //get important Benefits
                importantFetching: false,
                importantFetched: false,
                importantData: {},
                importantError: null,
                //get segmentation
                segmentationFetching: false,
                segmentationFetched: false,
                segmentationData: {},
                segmentationError: null,
                //add segmentation
                editFetching: false,
                editFetched: false,
                editData: {},
                editError: null, });
            break;
        }
    }
    return state;
}





// WEBPACK FOOTER //
// ./src/store/reducers/segmentationReducer.js